import axios from 'axios'
import moment from 'moment'
import { transformSelectedSetup } from '../api/utils'

const API_URL = `${process.env.REACT_APP_API_URL}`

const Report = {
  getReport(setup, date) {
    return axios({
      method: 'get',
      url: `${API_URL}/report`,
      params: {
        setup_name: transformSelectedSetup(setup),
        date: moment(date).format('YYYY-MM-DD'),
      },
      responseType: 'blob',
    })
  },
}

export default Report
